{
  "COMPONENTS": {
    "FILE_BUBBLE": {
      "DOWNLOAD": "Stáhnout",
      "UPLOADING": "Nahrávání..."
    },
    "FORM_BUBBLE": {
      "SUBMIT": "Odeslat"
    },
    "MESSAGE_BUBBLE": {
      "RETRY": "Odeslat zprávu znovu",
      "ERROR_MESSAGE": "Odeslání se nezdařilo, zkuste to znovu"
    }
  },
  "THUMBNAIL": {
    "AUTHOR": {
      "NOT_AVAILABLE": "Not available"
    }
  },
  "TEAM_AVAILABILITY": {
    "ONLINE": "Jsme online",
    "OFFLINE": "V současné době jsme pryč",
    "BACK_AS_SOON_AS_POSSIBLE": "We will be back as soon as possible"
  },
  "REPLY_TIME": {
    "IN_A_FEW_MINUTES": "Většinou odpovíme během pár minut",
    "IN_A_FEW_HOURS": "Většinou odpovíme během pár hodin",
    "IN_A_DAY": "Obvykle odpoví za den",
    "BACK_IN_HOURS": "We will be back online in {n} hour | We will be back online in {n} hours",
    "BACK_IN_MINUTES": "We will be back online in {time} minutes",
    "BACK_AT_TIME": "We will be back online at {time}",
    "BACK_ON_DAY": "We will be back online on {day}",
    "BACK_TOMORROW": "Zítra budeme opět k dispozici",
    "BACK_IN_SOME_TIME": "Za chvíli budeme opět k dispozici"
  },
  "DAY_NAMES": {
    "SUNDAY": "Neděle",
    "MONDAY": "Pondělí",
    "TUESDAY": "Úterý",
    "WEDNESDAY": "Středa",
    "THURSDAY": "Čtvrtek",
    "FRIDAY": "Pátek",
    "SATURDAY": "Sobota"
  },
  "START_CONVERSATION": "Zahájit konverzaci",
  "END_CONVERSATION": "Ukončit konverzaci",
  "CONTINUE_CONVERSATION": "Pokračovat v konverzaci",
  "YOU": "Vy",
  "START_NEW_CONVERSATION": "Zahájit novou konverzaci",
  "VIEW_UNREAD_MESSAGES": "Máte nepřečtené zprávy",
  "UNREAD_VIEW": {
    "VIEW_MESSAGES_BUTTON": "Zobrazit nové zprávy",
    "CLOSE_MESSAGES_BUTTON": "Zavřít",
    "COMPANY_FROM": "od",
    "BOT": "Bot"
  },
  "BUBBLE": {
    "LABEL": "Napiště nám"
  },
  "POWERED_BY": "Powered by Chatwoot",
  "EMAIL_PLACEHOLDER": "Prosím, zadejte svůj e-mail",
  "CHAT_PLACEHOLDER": "Zde začněte psát",
  "TODAY": "Dnes",
  "YESTERDAY": "Včera",
  "PRE_CHAT_FORM": {
    "FIELDS": {
      "FULL_NAME": {
        "LABEL": "Celé jméno",
        "PLACEHOLDER": "Zadejte své celé jméno",
        "REQUIRED_ERROR": "Je vyžadováno celé jméno"
      },
      "EMAIL_ADDRESS": {
        "LABEL": "E-mailová adresa",
        "PLACEHOLDER": "Zadejte prosím Váš e-mail",
        "REQUIRED_ERROR": "E-mailová adresa je vyžadována",
        "VALID_ERROR": "Zadejte prosím platnou e-mailovou adresu"
      },
      "PHONE_NUMBER": {
        "LABEL": "Telefonní číslo",
        "PLACEHOLDER": "Zadejte prosím Vaše telefonní číslo",
        "REQUIRED_ERROR": "Telefonní číslo je vyžadováno",
        "DIAL_CODE_VALID_ERROR": "Vyberte prosím kód země",
        "VALID_ERROR": "Zadejte prosím platné telefonní číslo",
        "DROPDOWN_EMPTY": "Žádné výsledky",
        "DROPDOWN_SEARCH": "Vyhledat zemi"
      },
      "MESSAGE": {
        "LABEL": "Zpráva",
        "PLACEHOLDER": "Zadejte prosím Vaši zprávu",
        "ERROR": "Zpráva je příliš krátká"
      }
    },
    "CAMPAIGN_HEADER": "Zadejte své jméno a e-mail před zahájením konverzace",
    "IS_REQUIRED": "je vyžadováno",
    "REQUIRED": "Povinné",
    "REGEX_ERROR": "Zadejte prosím platnou hodnotu"
  },
  "FILE_SIZE_LIMIT": "Soubor překračuje limit {MAXIMUM_FILE_UPLOAD_SIZE} přílohy",
  "CHAT_FORM": {
    "INVALID": {
      "FIELD": "Neplatné pole"
    }
  },
  "EMOJI": {
    "PLACEHOLDER": "Hledat emoji",
    "NOT_FOUND": "Žádné emoji neodpovídají vašemu hledání",
    "ARIA_LABEL": "Výběr emoji"
  },
  "EMOJI_ICON_PICKER": {
    "SEARCH_EMOJI": "Search emoji…",
    "FREQUENTLY_USED": "Frequently used",
    "NO_EMOJI": "No emoji match your search"
  },
  "CSAT": {
    "TITLE": "Ohodnoťte svou konverzaci",
    "SUBMITTED_TITLE": "Děkujeme Vám za odeslání hodnocení",
    "PLACEHOLDER": "Řekněte nám více..."
  },
  "EMAIL_TRANSCRIPT": {
    "BUTTON_TEXT": "Požádat o přepis konverzace",
    "SEND_EMAIL_SUCCESS": "Přepis chatu byl úspěšně odeslán",
    "SEND_EMAIL_ERROR": "Došlo k chybě, zkuste to prosím znovu"
  },
  "INTEGRATIONS": {
    "DYTE": {
      "CLICK_HERE_TO_JOIN": "Přidejte se kliknutím sem",
      "LEAVE_THE_ROOM": "Opustit hovor"
    }
  },
  "PORTAL": {
    "POPULAR_ARTICLES": "Populární články",
    "VIEW_ALL_ARTICLES": "Zobrazit všechny články",
    "IFRAME_LOAD_ERROR": "Při načítání článku došlo k chybě, obnovte stránku a zkuste to znovu."
  },
  "ATTACHMENTS": {
    "image": {
      "CONTENT": "Zpráva obrázku"
    },
    "audio": {
      "CONTENT": "Zvuková zpráva"
    },
    "video": {
      "CONTENT": "Video zpráva"
    },
    "file": {
      "CONTENT": "Přílohu souboru"
    },
    "location": {
      "CONTENT": "Poloha"
    },
    "fallback": {
      "CONTENT": "sdílel URL"
    }
  },
  "FOOTER_REPLY_TO": {
    "REPLY_TO": "Odpověď na:"
  }
}
